// /**
//  * Used by the module system.
//  * Makes sure that all contentBlocks using grid for layout/design has the same settings and widths accross the site.
// /*
import styled from 'libs/styled';
import { gridGap } from 'components/wrappers/ContentGridWrapper';

const ModuleGridWrapper = styled('div')``;

ModuleGridWrapper.defaultProps = {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    columnGap: [gridGap.mobile, null, null, gridGap.desktop],
};

export default ModuleGridWrapper;
